import styled from '@emotion/styled'

export const DeleteButton = styled.span`
  &:hover {
    color: ${({ theme }) => theme.colors.darkSkyBlue};
  }
`
